interface FileValidatorOptions {
  allowedTypes?: string[];
  maxSizeMB?: number;
}

export const useFileValidator = () => {
  const validateFile = (file: File, options: FileValidatorOptions) => {
    const isValidType = options.allowedTypes?.includes(file.type) ?? true;
    const isValidSize = options.maxSizeMB
      ? file.size <= options.maxSizeMB * 1024 * 1024
      : true;
    return { isValidType, isValidSize };
  };

  return { validateFile };
};
